/**
 * API Module - Assembles all domain endpoints into a single endpoints object
 * and re-exports the HTTP client
 */

export { apiRequest, api } from './client.js'

import { authEndpoints } from './auth.js'
import { quotesEndpoints, publicQuotesEndpoints, quoteAttemptsEndpoints, quoteEditorEndpoints, quoteSenderEmailsEndpoints, quoteNotificationEmailsEndpoints, lossReasonsEndpoints, clientCcContactsEndpoints } from './quotes.js'
import { contactsEndpoints } from './contacts.js'
import { usersEndpoints } from './users.js'
import { formationCatalogueEndpoints, formationsEndpoints } from './formations.js'
import { calendarEndpoints } from './calendar.js'
import { inscriptionsEndpoints, inscriptionStatsEndpoints, publicInscriptionsEndpoints, publicEmargementEndpoints, publicFormateurEmargementEndpoints, dossiersPedagogiquesEndpoints } from './inscriptions.js'
import { formateursEndpoints } from './formateurs.js'
import { missionsEndpoints } from './missions.js'
import { formateurPortailEndpoints, entrepriseEndpoints, stagiaireEndpoints, publicAutoFormationsEndpoints } from './portails.js'
import { questionnaireOrganisationEndpoints, publicQuestionnaireFormationEndpoints } from './questionnaires.js'
import { autoFormationsAdminEndpoints } from './auto-formations-admin.js'
import { messagesFormateurEndpoints } from './messaging.js'
import { appConfigEndpoints, configEndpoints, emailPreviewEndpoints, emailPreferencesEndpoints, userPreferencesEndpoints, apiKeysEndpoints, versionEndpoints, externalEndpoints, inseeEndpoints, unsubscribeEndpoints, debugEndpoints } from './config.js'
import { commentsEndpoints, callsEndpoints, logsEndpoints, statisticsEndpoints, notificationsEndpoints, exportsEndpoints, interSessionsEndpoints, sallesLocationEndpoints, companyProfilesEndpoints, advertisementsEndpoints } from './misc.js'
import { avisEndpoints } from './avis.js'
import { veilleEndpoints } from './veille.js'
import { feedbackEndpoints } from './feedback.js'
import { competencesEndpoints, materielsEndpoints, approchesPedagogiquesEndpoints, certificationsEndpoints, publicsFormesEndpoints, competencesReferentielEndpoints } from './cv-referentiels.js'
import { activityEndpoints } from './activity.js'
import { tasksEndpoints } from './tasks.js'
import { conciergerieEndpoints, conciergeriePortailEndpoints } from './conciergerie.js'
import { pointeuseEndpoints } from './pointeuse.js'

export const endpoints = {
  auth: authEndpoints,
  quotes: quotesEndpoints,
  tasks: tasksEndpoints,
  lossReasons: lossReasonsEndpoints,
  clientCcContacts: clientCcContactsEndpoints,
  publicQuotes: publicQuotesEndpoints,
  quoteAttempts: quoteAttemptsEndpoints,
  quoteEditor: quoteEditorEndpoints,
  quoteSenderEmails: quoteSenderEmailsEndpoints,
  quoteNotificationEmails: quoteNotificationEmailsEndpoints,
  contacts: contactsEndpoints,
  users: usersEndpoints,
  formationCatalogue: formationCatalogueEndpoints,
  formations: formationsEndpoints,
  calendar: calendarEndpoints,
  comments: commentsEndpoints,
  calls: callsEndpoints,
  logs: logsEndpoints,
  statistics: statisticsEndpoints,
  notifications: notificationsEndpoints,
  exports: exportsEndpoints,
  emailPreview: emailPreviewEndpoints,
  emailPreferences: emailPreferencesEndpoints,
  userPreferences: userPreferencesEndpoints,
  config: configEndpoints,
  apiKeys: apiKeysEndpoints,
  version: versionEndpoints,
  external: externalEndpoints,
  insee: inseeEndpoints,
  unsubscribe: unsubscribeEndpoints,
  interSessions: interSessionsEndpoints,
  sallesLocation: sallesLocationEndpoints,
  companyProfiles: companyProfilesEndpoints,
  advertisements: advertisementsEndpoints,
  inscriptions: inscriptionsEndpoints,
  inscriptionStats: inscriptionStatsEndpoints,
  publicInscriptions: publicInscriptionsEndpoints,
  publicEmargement: publicEmargementEndpoints,
  publicFormateurEmargement: publicFormateurEmargementEndpoints,
  publicQuestionnaireFormation: publicQuestionnaireFormationEndpoints,
  appConfig: appConfigEndpoints,
  formateurs: formateursEndpoints,
  questionnaireOrganisation: questionnaireOrganisationEndpoints,
  missions: missionsEndpoints,
  formateur: formateurPortailEndpoints,
  publicAutoFormations: publicAutoFormationsEndpoints,
  entreprise: entrepriseEndpoints,
  stagiaire: stagiaireEndpoints,
  messagesFormateur: messagesFormateurEndpoints,
  avis: avisEndpoints,
  veille: veilleEndpoints,
  feedback: feedbackEndpoints,
  debug: debugEndpoints,
  dossiersPedagogiques: dossiersPedagogiquesEndpoints,
  competences: competencesEndpoints,
  materiels: materielsEndpoints,
  approchesPedagogiques: approchesPedagogiquesEndpoints,
  certifications: certificationsEndpoints,
  publicsFormes: publicsFormesEndpoints,
  competencesReferentiel: competencesReferentielEndpoints,
  autoFormationsAdmin: autoFormationsAdminEndpoints,
  activity: activityEndpoints,
  conciergerie: conciergerieEndpoints,
  conciergeriePortail: conciergeriePortailEndpoints,
  pointeuse: pointeuseEndpoints,
}
